import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import AccountTable from '@modules/accounting/components/tables/account-table/account-table.vue';

@Component({
  name: 'bpc-accounts',
  components: {
    'bpc-account-table': AccountTable,
  },
})
export default class Accounts extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
